import React, { useState, useEffect} from "react";
import axios from "axios";
import { LocalConvenienceStoreOutlined, LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles,withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

// Components
import PurchaseOrderInfoTable from "./PurchaseOrderInfoTable";
import PurchaseAddItem from "./PurchaseAddItem";
import PurchaseEditShipping from "./PurchaseEditShipping";
//React Router (for getting parameters)
import {  useParams, useHistory } from "react-router-dom";

//number format plugin
import numeral from "numeral";
import { NavLink } from "react-router-dom";

import MessageBox from "../../components/MessageBox/MessageBox";
import LoadingModal from "../../components/Modal/LoadingModal";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#c1c3d8",
		display:"none"
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(89, 178, 89, 0.09)",
		padding: "1rem",
		border: "1.5px solid #59b259",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #59b259",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	root: {
		'&$disabled': {
		  color: '#f2f2f2',
		},
	  },
	  disabled: {},
	
});

const PurchaseOrderReturnEdit = () => {
	const { poretno, branchidno } = useParams();
	const [supplier, setSupplier] = useState([]);
	//const [warehouse, setWarehouse] = useState([]);
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in PO table
	const [supplierItem, setSupplierItem] = useState([]); //data to display in Add Item dropdown
	
	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [notes, setNotes] = useState('');

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(true);
	const [showModal, setShowModal] = useState(false);
	
	let history = useHistory();

	const addItem = (item) => {
		let found = items.some(x => x.item_id === item.id);
		if(found){
			//if item is existing in itemArray, add the qty instead
			let newItems = items.map((it)=> {
				if(it.item_id === item.id){ //add
					it.qty += item.qty;
			  	}
			  return it;
			});
			setItems(newItems);
		}else{
			//add new unique item to array
			setItems([...items, 
				{
				item_id: item.id, 
				qty: item.qty,
				price: item.cost, 
				uomDesc: item.uomDesc,
				item_name: item.itemname
				}
			]);
		}	
	}

	const deleteItem = (item_id) => {
		let itemArray = items.filter(item => item.item_id !== item_id);
		setItems(itemArray);
	}

	//update PO total when items update
	useEffect(() => {
		let po_total = 0;
		items.forEach(item => po_total += (item.price*item.qty));
		setPoTotal(po_total);

		if(items.length > 0) {
			setBtnDisabled(false); // re-enable
		}else{
			setBtnDisabled(true); // re-enable	
		}
	}, [items]);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		data();
		//console.log('refresh sir');
	}, []);

	const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	}))(Button);

	const data = async () => {
		const po_details = await axios.get(process.env.REACT_APP_API_URL+'get_returned_po_details', {
			params:{
				poretno: poretno,
				jc_u_idno: branchidno
			}
		}).then(function (response) {
				//console.log(response.data.data[1].poreturn_summary);
				setSupplier(response.data.data[1].poreturn_summary);
				setItems(response.data.data[2].poreturn_details);
				setShipTotal(response.data.data[1].poreturn_summary.shipping);
				setNotes(response.data.data[1].poreturn_summary.notes);
				// setSupplier(supplier_result.data.data);
				// setWarehouse(warehouse_result.data.data);
				// setSupplierItem(supplier_item_result.data.data);
				axios.get(process.env.REACT_APP_API_URL+'get_supplier_items_list', {
					params:{
						supplier_id: response.data.data[1].poreturn_summary.supplierid,  //supplier_id
										country:get_cookies('country'),
										curcode:get_cookies('curcode'),
										jc_idno:get_cookies('branchidno')
					}
				}).then(function (response) {
					//console.log(response.data.data);
					setSupplierItem(response.data.data);
				});
				// const warehouse_result = axios.get(process.env.REACT_APP_API_URL+'get_single_warehouse_data', {
				// 	params:{
				// 		warehouse_id: warehouseid,  //warehouse_id
				// 	}
				// });
				// const supplier_item_result = axios.get(process.env.REACT_APP_API_URL+'get_supplier_items_list', {
				// 	params:{
				// 		supplier_id: supid,  //supplier_id
				// 	}
				// });
		  }).catch(function (error) {
			// console.log(error);
		  });
	};
	


	const edit_po_return= async () => {
		// console.log(supplier.warehouse_id);
		// console.log(supplier.supplierid);
		setShowModal(true); //show loading/please wait modal
		setBtnDisabled(true); // re-enable
		const formData = new FormData();
		formData.append("poretno", poretno);
		formData.append("item_array", JSON.stringify(items));
		formData.append("supplier_id", supplier.supplierid);
		formData.append("jc_user_id_no", branchidno);
		formData.append("curcode", get_cookies('curcode'));
		formData.append("country", get_cookies('country'));
		formData.append("shipping", shipTotal);
		formData.append("trandate", supplier.date);
		formData.append("notes", notes);
		formData.append("jc_username", get_cookies('username'));
		formData.append("warehouse", supplier.warehouse_id);
	  
		await axios.post(process.env.REACT_APP_API_URL+'edit_po_return', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}
			}).then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("PO Return Updated");
				setMsgType("success");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					history.push('/purchases/purchases-order-return-transaction-history');
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
	}

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/purchases"}><h4 style={{color:"#339933"}}>Purchases</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<NavLink to={"/purchases/purchases-order-return"}><h4 style={{color:"#339933"}}>Purchase Order Return</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Edit PO Return #{poretno}</h4>
			</div>
			<div className="page-container">
				<LoadingModal showModal={showModal}/>
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card} style={{marginTop:"2.5em"}}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={12}>
								<div className={classes.subTitle}>
									Purchase Order Return
								</div>
								<div className={classes.title}>
									Purchase Order Return Information
								</div>
							</Grid>
							<Grid item xs={12} lg={8}>
								<Grid container spacing={3} style={{marginTop:"1.5em",justifyContent: "flex-end"}}>
									<PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/>
									{/* <div style={{marginRight: "0.5em"}}></div> */}
									<PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/>
									<LoadingModal showModal={showModal}/>
								</Grid>
							</Grid>	
					  </Grid>
					</div>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Date: 
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplier.date || "Date"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Returned To: 
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplier.returnedto || "Returned To"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Mode of Payment:
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplier.modeofpayment || "Mode of Payment"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Contact #:
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplier.contactno || "Contact Number"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Address:
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplier.address || "Address"}
								</Grid>
							</Grid>
						</div>
						<PurchaseOrderInfoTable items={items} setItems={setItems} deleteItem={deleteItem}/>
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div className={classes.infoTotalItem}>
									<LocalShippingTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Shipping: "+ numeral(shipTotal).format('0,0.00')}							
								</div>
								<div className={classes.infoTotalItem}>
									<ShoppingBasketTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Sub-Total: "+ numeral(poTotal).format('0,0.00')}
								</div>
								<div className={classes.infoTotalItem}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "+ numeral(Number(shipTotal)+Number(poTotal)).format('0,0.00')}
								</div>
							</div>
						</div>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							value={notes || ''}
							className={classes.textarea}
							onChange={(e)=>{setNotes(e.target.value)}}
						/>
					</CardContent>
				</Card>
				<div className={classes.buttonContainer}>
					{/* <Button variant="contained">Back</Button> */}
					<ColorButton disabled={btnDisabled} variant="contained" color="primary" onClick={edit_po_return}
					classes={{
						root: classes.root, 
							disabled: classes.disabled}}>
						Update
					</ColorButton>
				</div>
			</div>
		</div>
	);
};

export default PurchaseOrderReturnEdit;
